import { asPage } from 'src/components/hoc/asPage'
import { CompanyDataEditor } from 'src/compositions/Profile/CompanyData'

export default asPage(CompanyDataEditor, { pageTitle: '企業情報編集' })
